var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container text-block"},[_c('html-block',{staticClass:"text-block__child",class:_vm.class_list,attrs:{"content":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }